module.exports = __webpack_public_path__ + "img/icon-credit-card-blue@3x.7fb671ff.png";